
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { Utils } from './app/core/utils/utils';


const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

const azureMsalProtectedResourceMap = new Map();
const azureMsalGraphApiUrl = Utils.getApplicationConfigData('AZURE_MSAL_GRAPH_API_URL');
if (Utils.notNullAndNotUndefined(azureMsalGraphApiUrl) && azureMsalGraphApiUrl.length > 0) {
    azureMsalProtectedResourceMap.set(azureMsalGraphApiUrl, ['user.read', 'Mail.ReadWrite']);
}

export function MSALInstanceFactory(): PublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: Utils.getApplicationConfigData('AZURE_MSAL_AUTH_CLIENTID'),
            authority: Utils.getApplicationConfigData('AZURE_MSAL_AUTH_AUTHORITY'),
            redirectUri: Utils.getApplicationConfigData('AZURE_MSAL_AUTH_REDIRECT_URI'),
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: isIE,
        },
    });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['user.read', 'Mail.ReadWrite', 'Mail.Send'],
        },
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: azureMsalProtectedResourceMap,
    };
}
